import { Skeleton } from '@/components/ui/skeleton/skeleton.component';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const CardViewSkeleton = (props: Props) => {
  return (
    <div {...props} className="grid grid-cols-4 gap-3 xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {Array.from(Array(10).keys()).map((i) => (
        <div
          key={i}
          className="rounded shadow border border-light-gray flex-1 h-[188px] min-h-[188px] max-h-[188px] p-4 space-y-2"
        >
          <div className="flex flex-row justify-between items-center">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-6" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-8" />
            <div className="h-[1px] border-b border-light-gray" />
            <Skeleton className="h-6 w-40" />
            <Skeleton className="h-6" />
          </div>
        </div>
      ))}
    </div>
  );
};
